<template>
  <v-main>
    <v-container fluid>
      <v-card elevation="6" rounded="xxl">
        <v-card-title class="mt-4">
          <v-btn
            class="mx-2"
            fab
            x-small
            color="primary"
            @click="$router.back()"
          >
            <v-icon dark> mdi-arrow-left </v-icon> </v-btn
          >Edit Sale
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col sm="4">
              <v-autocomplete
                ref="user"
                outlined
                v-model="form.user_id"
                :items="driverItems"
                label="User"
                prepend-inner-icon="mdi-account"
                clearable
                :error-messages="errors.user_id"
              ></v-autocomplete>
            </v-col>
            <v-col sm="4">
              <v-autocomplete
                ref="product"
                outlined
                v-model="form.product_id"
                :items="productItems"
                label="Product"
                prepend-inner-icon="mdi-archive-star"
                clearable
                :error-messages="errors.product_id"
              ></v-autocomplete>
            </v-col>
            <v-col sm="4">
              <v-menu
                v-model="date_menu"
                :close-on-content-click="true"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="form.date"
                    label="Date"
                    prepend-inner-icon="mdi-calendar"
                    v-bind="attrs"
                    v-on="on"
                    outlined
                    readonly
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="form.date"
                  @input="date_menu = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.quantity"
                outlined
                label="Quantity"
                prepend-inner-icon="mdi-archive-star"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.round_of_amount"
                outlined
                label="Round Of Amount"
                prepend-inner-icon="mdi-currency-rupee"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.driver_name"
                outlined
                label="Driver Name"
                prepend-inner-icon="mdi-card-account-details"
                :error-messages="errors.driver_name"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.driver_phone"
                outlined
                label="Driver Phone"
                prepend-inner-icon="mdi-card-account-details"
                :error-messages="errors.driver_phone"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.recieved_amount"
                outlined
                label="Recieved Amount"
                prepend-inner-icon="mdi-currency-rupee"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.balance_amount"
                outlined
                label="Balance Amount"
                prepend-inner-icon="mdi-currency-rupee"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.note"
                outlined
                label="Note"
                prepend-inner-icon="mdi-card-text-outline"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.phone"
                outlined
                label="Phone"
                prepend-inner-icon="mdi-phone"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.vehicle_registration_no"
                outlined
                label="Vehicle Registration No"
                prepend-inner-icon="mdi-car-back"
                :error-messages="errors.vehicle_registration_no"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.amount"
                outlined
                label="Amount"
                prepend-inner-icon="mdi-currency-rupee"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.point_earned"
                outlined
                label="Point Earned"
                prepend-inner-icon="mdi-hand-coin"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-menu
                v-model="point_valid_till_menu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="form.point_valid_till"
                    label="point valid till"
                    prepend-inner-icon="mdi-calendar"
                    v-bind="attrs"
                    v-on="on"
                    outlined
                    readonly
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="form.point_valid_till"
                  @input="point_valid_till_menu = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col>
              <v-switch
                class="mt-0 ml-5"
                v-model="form.is_recieved"
                inset
                :label="`Is Recieved: ${form.is_recieved ? 'YES' : 'NO'}`"
              ></v-switch>
            </v-col>
            <!-- <v-col>
              <input
                type="file"
                id="document_path"
                name="document_path"
                ref="document_path"
                accept="image/*"
                @input="handleFileUpload"
              />
            </v-col> -->
          </v-row>
          <v-divider class="my-5"> </v-divider>
          <v-btn
            rounded
            color="primary"
            :loading="isLoading"
            :disabled="isLoading"
            @click="save"
          >
            Update Sale
          </v-btn>
        </v-card-text>
      </v-card>
    </v-container>
  </v-main>
</template>
<script>
import axios from "axios";

export default {
  name: "SaleEditPage",
  data() {
    return {
      form: {
        is_active: false,
      },
      storeItems: [],
      sale: [],
      driverItems: [],
      productItems: [],
      isLoading: false,
      point_valid_till_menu: false,
      date_menu: false,
    };
  },
  mounted() {
    this.getData();
    this.getMasters();
  },
  methods: {
    async getMasters() {
      await axios
        .get(`sales/masters`)
        .then((masters) => {
          masters = masters.data;
          //Stores
          // masters.stores.forEach((store) => {
          //   this.storeItems.push({
          //     id: store.id,
          //     text: store.name,
          //     value: store.id,
          //   });
          // });
          //Users
          masters.users.forEach((user) => {
            this.driverItems.push({
              id: user.id,
              text: user.user_name,
              value: user.id,
            });
          });
          //Products
          masters.products.forEach((product) => {
            this.productItems.push({
              id: product.id,
              text: product.name,
              value: product.id,
            });
          });
        })
        .catch(function (error) {
          console.log(error);
          // redirect to Home Page
          window.location.href = "/auth/login";
        });
    },
    async getData() {
      this.isLoading = true;
      let encryptedId = this.$route.params.saleId;
      axios
        .get(`/sales/${encryptedId}`)
        .then((response) => {
          this.form = response.data.data;
          this.form.driver_name = this.form.driver.first_name;
          this.form.driver_phone = this.form.driver.phone;
          this.old_json = response.data.data;
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
      this.isLoading = false;
    },
    async save() {
      try {
        this.isLoading = true;
        console.log(this.form);
        this.sale = await axios.patch(
          `/sales/${this.$route.params.saleId}`,
          this.form
        );
        await this.saveUserTimestamp(this.old_json, this.form);
        this.isLoading = false;
      } catch (e) {
        this.isLoading = false;
        console.log(e);
      }
    },
    async saveUserTimestamp() {
      try {
        let form = {
          from_path: `/sale/${this.form.id}`,
          from_name: "SaleEditPage",
          user_id: this.user.id,
          old_json: JSON.stringify(this.old_json),
          new_json: JSON.stringify(this.form),
        };
        await axios.post(`/user_timestamps`, form);
        this.$router.push("/sales");
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
